import { CircleX, X } from "lucide-react";
import { Dialog } from "./catalyst/dialog";
import { AnimateChangeInHeight } from "./components/AnimateChangeInHeight";
import memStore from "./lib/memStore";

export type Props = {
  open: boolean;
  onClose?: () => void;

  title: string;
  subtitle?: string;
};

export default function ErrorModal({ open, onClose, title, subtitle }: Props) {
  const closeModal = () => {
    if (!onClose) return;

    window.parent?.postMessage({ type: "close" }, "*");
    memStore.clear();

    onClose();
  };

  return (
    <div className={onClose ? "min-h-dvh bg-[--color-modal-backdrop]" : ""}>
      <Dialog open={open} onClose={() => closeModal()} size="sm">
        <AnimateChangeInHeight>
          <div>
            <div className="my-4 flex flex-col items-center justify-center">
              <CircleX className="h-12 w-12 text-red-500" />

              <div className="mt-2 font-medium text-lg text-center text-[--color-text-primary]">
                {title}
              </div>
              {subtitle ? (
                <div className="text-[--color-text-secondary] text-center text-sm">
                  {subtitle}
                </div>
              ) : null}
            </div>
          </div>

          {onClose ? (
            <button
              className="p-1 transition-colors hover:bg-[--color-background-secondary] absolute top-4 right-4 rounded-lg text-[--color-text-primary]"
              onClick={() => closeModal()}
            >
              <X className="h-5 w-5" />
            </button>
          ) : null}
        </AnimateChangeInHeight>
      </Dialog>
    </div>
  );
}
